import React from 'react';
import {BrowserRouter, Routes, Route} from 'react-router-dom'
import Home from './PAGES/Home/Home';
import Reservation from './PAGES/Reservation/Reservation';
import Payment from './PAGES/Payment/Index';
import Profil from './PAGES/Profil/Profil';
import AuthGuard from './AuthGuard'
import { CartProvider } from './CartContext';
import ForgotPassword from './PAGES/Login/ForgotPassword';
import NewPassword from './PAGES/Login/NewPassword';
import Document from './PAGES/Documents/document';
import Login from './PAGES/Login/Login';

function App() {
  return (
   <BrowserRouter>
   <CartProvider>
    <Routes>
    
          <Route path='/' element={<AuthGuard><Home/></AuthGuard>} />

          {/* <Route path="/" element={<AuthGuard> <Home /> </AuthGuard>} /> */}
          <Route path="/payment" element={<AuthGuard> <Payment /> </AuthGuard>} />
          <Route path='/reservation' element={<AuthGuard><Reservation/></AuthGuard>} />
          <Route path='/login' element={<Login/>} />
          <Route path='/profil' element={<AuthGuard><Profil/></AuthGuard>} />
          <Route path='/forgotPassword' element={<ForgotPassword/>} ></Route>
          <Route path='/new-password' element={<NewPassword/>} ></Route>
          <Route path='/document' element={<Document/>} ></Route>
          {/* <Route path='/logout' /> */}
    </Routes>
   </CartProvider>
   </BrowserRouter>
  );
}

export default App;
